function FailEnquiryDiv(props) {
    return (
      <>
        <div className={props.class}>
            { props.msg !== undefined ? 
              <p>{props.msg}</p> : 
              <p>若您無法完成登記以獲取印花，請致電顧客服務熱線查詢(上午9:00 至 晚上9:00)：</p>
            }
            香港 <a href="tel:+852 2300 1800"><span class="font-blue">+852 2300 1800</span></a><br />
            內地 <a href="tel:+86 400 120 1339"><span class="font-blue">+86 400 120 1339</span></a><br />
            澳門 <a href="tel:+853 0800218"><span class="font-blue">+853 0800218</span></a>
        </div>
      </>
    );
  }
  
export default FailEnquiryDiv;